import React from 'react';
// Assumindo que formatCurrency está em 'formatters.js' como no App.js original
import { formatCurrency } from './formatters'; 

/**
 * Componente de Tooltip customizado para os gráficos da biblioteca Recharts.
 * Exibe detalhes sobre os dados quando o usuário passa o mouse sobre uma barra do gráfico.
 * @param {object} props - Propriedades passadas pelo Recharts.
 * @param {boolean} props.active - Indica se o tooltip deve ser exibido.
 * @param {Array} props.payload - Contém os dados do ponto específico do gráfico.
 * @param {string} props.label - O rótulo do eixo X para o ponto de dados.
 * @returns {React.Component|null} O componente do tooltip ou nulo se não estiver ativo.
 */
const CustomTooltip = ({ active, payload, label }) => {
    // Renderiza o tooltip apenas se estiver ativo e com dados
    if (active && payload && payload.length) {
        // Extrai os valores do payload
        const regularizados = payload.find(p => p.dataKey === 'regularizados')?.value || 0;
        const aRegularizar = payload.find(p => p.dataKey === 'aRegularizar')?.value || 0;
        const total = regularizados + aRegularizar;
        
        const custoAtual = payload.find(p => p.dataKey === 'custoAtual')?.value || 0;
        const custoProjetado = payload.find(p => p.dataKey === 'custoProjetado')?.value || 0;

        // Calcula a porcentagem de postes regularizados
        const percentRegularizado = total > 0 ? ((regularizados / total) * 100).toFixed(1) : 0;
        
        return (
            <div className="p-4 bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border border-slate-300 dark:border-slate-700 rounded-lg shadow-lg">
                <p className="font-bold text-slate-800 dark:text-slate-100 mb-2">{label}</p>
                
                {/* Informações sobre a quantidade de postes */}
                <p className="text-sm text-blue-600 dark:text-blue-400">{`Regularizados: ${regularizados}`}</p>
                <p className="text-sm text-indigo-600 dark:text-indigo-400">{`A Regularizar: ${aRegularizar}`}</p>
                <p className="text-sm text-slate-700 dark:text-slate-300 font-semibold">{`Total: ${total} (${percentRegularizado}%)`}</p>

                {/* Divisor */}
                <div className="border-t border-slate-300 dark:border-slate-600 mt-2 pt-2">
                    {/* Informações sobre custos */}
                    <p className="text-sm text-red-600 dark:text-red-400 font-semibold">{`Custo Atual: ${formatCurrency(custoAtual)}`}</p>
                    <p className="text-sm text-orange-600 dark:text-orange-400 font-semibold">{`Custo Projetado: ${formatCurrency(custoProjetado)}`}</p>
                </div>
            </div>
        );
    }
    // Retorna nulo se o tooltip não deve ser exibido
    return null;
};

export default CustomTooltip;
